import { DetailTabs } from "../../components/detailTabs/DetailTabs";
import { EntityForm } from "../../components/entityForm/EntityForm";
import { Groups } from "../../components/groups/Groups";
import { Record } from "../../components/record/Record";
import { Records } from "../../components/records/Records";
import { RecordsRelated } from "../../components/recordsRelated/RecordsRelated";
import { processesOptions } from "../../screens-processes/processesOptions";
import { categoriesChildOptions } from "./categoriesChildOptions";
import { tabs } from "./categoriesChildTabs";

export const fieldsQuery = "*.*";

export const categoriesChildRoutes = [
  {
    path: "/process_category",
    element: <Records entity="process_category" fieldsQuery={fieldsQuery} />,
  },

  {
    path: "/process_category/:id",
    element: (
      <Record
        entity="process_category"
        type="detail"
        fieldsQuery={fieldsQuery}
        body={<DetailTabs tabs={tabs} />}
      />
    ),
    children: [
      {
        path: "/process_category/:id/detail",
        element: <Groups groupsOptions={categoriesChildOptions.groupsOptions} />,
      },
      {
        element: (
          <RecordsRelated
            entity="processes"
            fieldsToQuery="*.*"
            fieldToFilter="process_category"
            recordsOptions={processesOptions}
            heightOfHeaders={398}
          />
        ),
        path: "/process_category/:id/processes",
      },
    ],
  },
  {
    path: "/process_category/:id/update",
    element: (
      <Record
        entity="process_category"
        type="update"
        fieldsQuery={fieldsQuery}
        body={<EntityForm groupsOptions={categoriesChildOptions.groupsOptions} />}
      />
    ),
  },

  {
    path: "/process_category/create",
    element: (
      <Record
        entity="process_category"
        type="create"
        body={<EntityForm groupsOptions={categoriesChildOptions.groupsOptions} />}
      />
    ),
  },
];
